import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceManagementCustomerPermissionsRoute: InvariantJiraRoute =
	{
		name: 'project-settings-customer-service-management-customer-permissions',
		path: '/jira/customer-service-management/projects/:projectKey/settings/customer-permissions',
		exact: true,
	};
